import type { ReactElement, SVGProps } from "react";
import { cn } from "@/lib/utils";

type Severity = "error" | "warning" | "info";

const ICON_COLORS: Record<Severity, string> = {
  error: "var(--color-red)",
  warning: "var(--color-amber)",
  info: "var(--color-blue)",
};

export function ErrorIcon({
  severity,
  ...props
}: SVGProps<SVGSVGElement> & { severity: Severity }): ReactElement {
  const c = ICON_COLORS[severity];
  if (severity === "warning") {
    return (
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        {...props}
        className={cn("shrink-0", props.className)}
      >
        <path
          d="M8 1.5L14.5 13H1.5L8 1.5Z"
          stroke={c}
          strokeWidth="1.3"
          strokeLinejoin="round"
        />
        <path d="M8 6.5V9" stroke={c} strokeWidth="1.3" strokeLinecap="round" />
        <circle cx="8" cy="11" r="0.65" fill={c} />
      </svg>
    );
  }
  if (severity === "info") {
    return (
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        {...props}
        className={cn("shrink-0", props.className)}
      >
        <circle cx="8" cy="8" r="6.5" stroke={c} strokeWidth="1.3" />
        <path d="M8 5V5.5" stroke={c} strokeWidth="1.3" strokeLinecap="round" />
        <path
          d="M8 7.5V11"
          stroke={c}
          strokeWidth="1.3"
          strokeLinecap="round"
        />
      </svg>
    );
  }
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      {...props}
      className={cn("shrink-0", props.className)}
    >
      <circle cx="8" cy="8" r="6.5" stroke={c} strokeWidth="1.3" />
      <path
        d="M6 6L10 10M10 6L6 10"
        stroke={c}
        strokeWidth="1.3"
        strokeLinecap="round"
      />
    </svg>
  );
}
